import { OIDC_STORE_PREFIX, TSG_ID_NONE } from '../../framework/constants'
import { getDatadogRum } from '../../framework/externals'
import { stateRef } from '../../framework/store'
import { __isLocalhost } from '../../init/debug'

export const isNoneTsg = () => {
  const tsgId = stateRef.current.auth?.tsg_id
  return tsgId === TSG_ID_NONE
}

export const globalAvail = () => {
  const tsgId = stateRef.current.auth?.tsg_id
  return !tsgId || tsgId !== TSG_ID_NONE
}

export const noTsgAccess = () => Boolean(stateRef.current.auth?.access?.noRoleAccess)
export const isIPRestricted = () => Boolean(stateRef.current.auth?.instances?.error?.ipRestricted)
export const tsgAccessAvail = () => !noTsgAccess() && !isIPRestricted()

export const globalAndTsgAvail = () => globalAvail() && !noTsgAccess()

export const clearOidcSessionStorage = () => {
  for (const key of Object.keys(sessionStorage)) {
    if (key.startsWith(OIDC_STORE_PREFIX)) {
      sessionStorage.removeItem(key)
    }
  }
}

const ddTiming = {} as Record<string, number>
export const addDataDogTimingOnce = (name: string, value: number) => {
  const dd = getDatadogRum()
  if (dd && !__isLocalhost && !ddTiming[name]) {
    dd.addTiming(name, value)
    ddTiming[name] = value
  }
}
